export const initialDrawerInfo = {
  title: "",
  visibility: false,
  type: "",
};

export enum DrawerTypes {
  GROUP_NO = "groupNo",
  BELONGS_TO = "belongsTo",
  POSTAL_CODE = "postalCode",
  ADDRESS_HISTORY = "addressHistory",
  ENTITY_HISTORY = "entityHistory",
}

export enum PostalCodeParams {
  COUNTRY_CODE = "NO",
  POSTAL_CODE = "PostalCode",
  ALL_SEARCH_TYPE = "all",
}

export const CreditorColors = [
  { value: "none", colorName: "None" },
  { value: "ff44aa", colorName: "Pink" },
  { value: "8f44c4", colorName: "Purple" },
  { value: "00d192", colorName: "Teal" },
  { value: "58ddff", colorName: "Light Blue" },
  { value: "ff7c00", colorName: "Orange" },
  { value: "bf8125", colorName: "Brown" },
  { value: "b6ca11", colorName: "Lime Green" },
  { value: "309c00", colorName: "Green" },
  { value: "df274c", colorName: "Crimson" },
  { value: "136bc2", colorName: "Blue" },
];

export const initialCreditorData = {
  entRoleId: -1,
  entId: -1,
  creditorNumber: '',
  creditorName:  '',
  groupNo:  '',
  groupName:  '',
  belongsTo:  '',
  belongsToId:  0,
  nin:  '',
  account:  '',
  accountNo:  '',
  productNo:  '',
  caseHandler: "",
  agreement: "",
  address1:  '',
  address2: '',
  address3: '',
  country: 'NO',
  postalCode: '',
  postalPlace: '',
  email: '',
  direct: '',
  mobile: '',
  office: '',
  fax: '',
  im1: '',
  im2: '',
  im3: '',
  AllowMoveToBMD: false,
  GetBelongsToSettings: false,
  bankGiro: false,
  creditorColor: CreditorColors[0].value,
  creditorColorDescription: "",
};
